import { hasAnalyticsConsent } from './consent';

let initializationPromise: Promise<boolean> | null = null;

/**
 * Loads the monitoring SDK only after explicit analytics consent. Keeping the
 * SDK behind this seam avoids shipping replay/tracing code in the critical path.
 */
export function initializeConsentedSentry(): Promise<boolean> {
  if (!hasAnalyticsConsent()) {
    return Promise.resolve(false);
  }

  initializationPromise ??= import('./sentry')
    .then(({ initSentry, wrapFetch }) => {
      initSentry();
      wrapFetch();
      return true;
    })
    .catch(() => {
      initializationPromise = null;
      return false;
    });

  return initializationPromise;
}

export async function captureConsentedException(
  error: Error,
  context?: {
    tags?: Record<string, string>;
    extra?: Record<string, unknown>;
    level?: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';
  },
): Promise<void> {
  if (!(await initializeConsentedSentry())) {
    return;
  }

  const { captureException } = await import('./sentry');
  captureException(error, context);
}
